export enum FilterStatus {
  All = "all",
  Read = "read",
  Unseen = "unseen",
  Unread = "unread",
}

export type ColorMode = "light" | "dark";
